import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export const theme = {
  Default: 'dark',
  Light: 'light',
  Dark: 'dark',
};

export const isExternalUserAtom = atom(false);

const themeStorage = createJSONStorage<string | null>(() => localStorage);

const themeSelectAtom = atomWithStorage(
  'jotai-selected-theme',
  theme.Default,
  themeStorage,
);

export const themeAtom = atom(
  (get) => get(themeSelectAtom) ?? theme.Default,
  (get, set, themeValue: string) => {
    get(themeSelectAtom);
    set(themeSelectAtom, themeValue);
  },
);

export const isHoveringUserValidationFindingAtom = atom(false);
